// write class function to render the home screen
import React, { Component } from 'react';
import { Text, View } from 'react-native';
import init from 'react_native_mqtt';
import AsyncStorage from '@react-native-async-storage/async-storage';
import config from '../config';
import { Box, Button, Grid2, Stack, Typography } from '@mui/material';
import i18n from './../util/i18n';
import { getTrackDetails } from '../services/spotify.service';
import { Image } from 'react-native-web';
import QRCode from "react-qr-code";

i18n.locale = navigator.language;

init({
    size: 10000,
    storageBackend: AsyncStorage,
    defaultExpires: 1000 * 3600 * 24,
    enableCache: true,
    reconnect: true,
    sync: {
    }
});


const STATES = {
    WAITING: 'waiting',
    PLAYING: 'playing',
    ANSWER: 'answer',
    RESULT: 'result',
}


export default class Display extends Component {

    constructor(props) {
        super(props);
        this.state = {

            currentState: STATES.WAITING,

            loading: true,
            mqttStatus: 'connecting',
            songId: '',
            songType: '',
            categoryId: '',
            categoryName: '',
            timeout: '',
            countdown: '',
            simpleCountdown: '',
            disabled: false,
            timeoutId: null,
            timeoutTimeInSeconds: null,
            artistDisabled: false,
            releaseDisabled: false,
            groupTotalPoints: 0,
            totalPoints: 0,
            totalBonus: 0,
            artistResponse: '',
            releaseResponse: '',
            movieResponse: '',
            hasRelease: true,
            hasArtist: true,
            hasMovie: true,
            trackDetails: null,
        };

        this.client = null;

        // Connect to MQTT broker here
        let clientId = Math.random().toString(36).substring(7);
        // this.client = new Paho.MQTT.Client(config.mqtt.host, clientId);
        let url = `${config.mqtt.host}`;
        this.client = new Paho.MQTT.Client(url, clientId);
        this.client.onConnectionLost = this.onConnectionLost;
        this.client.onMessageArrived = this.onMessageArrived;
        this.client.connect({
            useSSL: false,
            // userName:config.mqtt.user,
            // password:config.mqtt.pass,
            onSuccess: this.onConnect,
            onFailure: this.onFailure
        });
        this.movieRef = React.createRef();
        this.releaseRef = React.createRef();
        this.artistRef = React.createRef();
    }


    // set state async
    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve)
        });
    }

    componentDidMount() {

    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    simpleCountdown = (seconds) => {
        let countdown = seconds;
        this.setState({ simpleCountdown: seconds });
        this.interval = setInterval(() => {
            countdown--;
            this.setState({ simpleCountdown: countdown });
            if (countdown <= 0) {
                clearInterval(this.interval);
                this.setState({ simpleCountdown: '' });
            }
        }, 1000);
    }

    showCountdown = (timeoutTime, solutionDisplayTime, solutionDisplayTimeInSeconds) => {
        let remainingTime = Math.max((timeoutTime - new Date().getTime()), 0) + Math.max((solutionDisplayTime - new Date().getTime()), 0);
        if (remainingTime <= 0) {
            this.setState({ countdown: '', songId: '', songType: '', categoryId: '', categoryName: '', currentState: STATES.WAITING });
            return;
        }

        remainingTime = timeoutTime - new Date().getTime();

        this.setState({ countdown: parseInt(remainingTime / 1000) });

        if (remainingTime >= 0) {
            setTimeout(() => {

                if (this.state.countdown === '') {
                    this.setState({ songId: '', songType: '', categoryId: '', categoryName: '', currentState: STATES.WAITING });
                    return;
                }

                this.showCountdown(timeoutTime, solutionDisplayTime, solutionDisplayTimeInSeconds);
            }, 100);
        } else {
            this.setState({ countdown: '', currentState: STATES.ANSWER });
            this.simpleCountdown(solutionDisplayTimeInSeconds);
            setTimeout(() => {
                this.setState({ songId: '', songType: '', categoryId: '', categoryName: '', currentState: STATES.WAITING });
            }, solutionDisplayTimeInSeconds * 1000);
        }
    }

    getSongDetails = async (song_id) => {
        let response = await getTrackDetails(song_id);
        await this.setStateAsync({ trackDetails: response });
        // if has movie is true focus to movie field else focus to release field
    }


    onConnect = () => {
        console.log("Connected to MQTT Broker!");
        this.client.subscribe(config.mqtt.topic);
        this.setState({ mqttStatus: 'connected' });
    }

    onFailure = (responseObject) => {
        this.setState({ mqttStatus: 'failed' });
        console.log("Connection to MQTT Broker Failed: ", responseObject.errorMessage);
    }

    onConnectionLost = (responseObject) => {
        if (responseObject.errorCode !== 0) {
            this.setState({ mqttStatus: 'lost' });
            console.log("Connection Lost: ", responseObject.errorMessage);
        }
    }

    onMessageArrived = async (message) => {


        // let songId = message.topic.split('/')[2];
        let payloadString = JSON.parse(message.payloadString)

        const mode = payloadString.mode;
        if (mode === 'stop') {
            this.setState({ countdown: '' });
            return;
        }

        let songId = payloadString.songId;
        let songType = payloadString.songType;
        let categoryId = payloadString.categoryId;
        let categoryName = payloadString.categoryName;
        let timeoutTime = payloadString.timeoutTime;
        let solutionDisplayTime = payloadString.solutionDisplayTime;
        let solutionDisplayTimeInSeconds = payloadString.solutionDisplayTimeInSeconds;

        await this.setStateAsync({ songId, songType, categoryId, categoryName, currentState: STATES.PLAYING, solutionDisplayTime: solutionDisplayTime });

        this.showCountdown(timeoutTime, solutionDisplayTime, solutionDisplayTimeInSeconds);
        this.setState({ timeoutTimeInSeconds: payloadString.timeoutTimeInSeconds });
        this.getSongDetails(songId);
    }


    waitingRender = () => {
        return (
            <Grid2 container spacing={2} sx={{ width: '100vw', height: '100vh' }} justifyContent={'center'} alignItems={'center'}
                style={{ backgroundColor: 'black' }}
                flexDirection={'column'}
            >

                <Image source={require('./../assets/logo.png')} style={{ aspectRatio: 1, height: '80%' }} />


                {/* <Stack spacing={2} alignItems="center" direction={'row'}>

                    <Button
                        variant='outlined'
                        size='large'
                        style={{ color: 'white', borderColor: 'white', borderWidth: 2, borderRadius: 10, paddingRight: 20, paddingLeft: 20, paddingTop: 10, paddingBottom: 10, margin: 20, fontSize: 30 }}
                        onClick={() => {
                            this.props.navigation.navigate('Answers');
                        }}
                    >
                        {i18n.t('answers')}
                    </Button>

                    <Button
                        variant='outlined'
                        size='large'
                        style={{ color: 'white', borderColor: 'white', borderWidth: 2, borderRadius: 10, paddingRight: 20, paddingLeft: 20, paddingTop: 10, paddingBottom: 10, margin: 20, fontSize: 30 }}
                        onClick={() => {
                            this.props.navigation.navigate('Points');
                        }}
                    >
                        {i18n.t('points')}
                    </Button>

                </Stack> */}

            </Grid2>
        );
    }

    playingRender = () => {
        return (
            <Grid2 container spacing={2} sx={{ width: '100vw', height: '100vh' }} justifyContent={'space-around'} alignItems={'center'}
                style={{ backgroundColor: 'black' }}
                flexDirection={'row'}
            >
                <Grid2 item xs={6} sm={6} md={6} lg={6} xl={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                    <Typography variant="h1" component="div" sx={{ fontWeight: 'bold', color: 'white', textAlign: 'center' }}>{this.state.categoryName}</Typography>
                    <br /><br />
                    <Typography variant="h2" component="div" sx={{ fontWeight: 'bold', color: 'white', textAlign: 'center' }}>{this.state.songType}</Typography>
                </Grid2>
                <Grid2 item xs={6} sm={6} md={6} lg={6} xl={6} 
                    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden', textAlign: 'center' }}
                >
                    <Typography 
                        variant="h1" 
                        component="div" 
                        sx={{ 
                            fontWeight: 'bold', 
                            color: 'white', 
                            fontSize: 'clamp(50px, 50vw, 700px)', 
                        }}
                    >
                        {this.state.countdown}
                    </Typography>
                </Grid2>
            </Grid2>
        );
    }

    answerRender = () => {
        return (
            <Grid2 container spacing={2} sx={{ width: '100vw', height: '100vh' }}
                style={{ backgroundColor: 'black' }}
                flexDirection={'column'}
            >
                {(!this.state.trackDetails) ? (
                    <Box sx={{ textAlign: 'center' }} alignItems={'center'}>
                        <Text style={{ fontSize: 50, fontWeight: 'bold', color: 'white' }}>{i18n.t('loading')}</Text>
                    </Box>
                ) : (
                    <Stack spacing={2} alignItems="center" direction={'column'} style={{ width: '100%', height: '100%' }}>

                        <Stack spacing={2} alignItems="right" direction={'row'} style={{ width: '100%', textAlign: 'right', alignItems: 'right' }}>
                            <Typography variant="h1" component="div" sx={{ width: '100%', fontWeight: 'bold', color: 'white', alignItems: 'right', paddingRight: '50px' }}>{this.state.simpleCountdown}</Typography>
                        </Stack>
                        
                        
                        <Stack spacing={2} alignItems="center" justifyContent={'space-around'} direction={'row'} style={{ width: '100%', textAlign: 'right', alignItems: 'flex-end', display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="h3" component="div" sx={{ fontWeight: 'bold', color: 'white', textAlign: 'right', paddingRight: '50px', marginBottom: '20px' }}>{`${this.state.categoryName}`}</Typography>
                            <Typography variant="h3" component="div" sx={{ fontWeight: 'bold', color: 'white', textAlign: 'right', paddingRight: '50px' }}>{`${this.state.songType}`}</Typography>
                        </Stack>

                        <Stack spacing={2} alignItems="center" direction={'row'} justifyContent={'space-around'} style={{ width: '100%', height: '100%' }}>
                            <Grid2 item xs={12} sm={4} md={4} lg={6} xl={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                {(this.state?.trackDetails?.song?.artist?.name) ? (
                                    <Typography variant="h3" component="div" sx={{ fontWeight: 'bold', color: 'white', textAlign: 'center' }}>{this.state.trackDetails.song.artist.name}</Typography>
                                ) : null}

                                <br /><br />

                                {(this.state?.trackDetails?.song?.release?.title) ? (
                                    <Typography variant="h3" component="div" sx={{ fontWeight: 'bold', color: 'white', textAlign: 'center' }}>{this.state.trackDetails.song.release.title}</Typography>
                                ) : null}

                                <br /><br />

                                {(this.state?.trackDetails?.song?.movie?.name) ? (
                                    <Typography variant="h3" component="div" sx={{ fontWeight: 'bold', color: 'white', textAlign: 'center' }}>{this.state.trackDetails.song.movie.name}</Typography>
                                ) : null}

                                <br /><br />
                                
                                {(this.state?.trackDetails?.song?.language?.name) ? (
                                    <Typography variant="h3" component="div" sx={{ fontWeight: 'bold', color: 'white', textAlign: 'center' }}>{this.state.trackDetails.song.language.name}</Typography>
                                ) : null}
                            </Grid2>
                            <Grid2 item xs={12} sm={4} md={4} lg={6} xl={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                                {(this.state?.trackDetails?.customTrackImage) ? (
                                    <div style={{ backgroundColor: 'white', padding: 20, width: '90%'}}>
                                        <img
                                            src={`${config.baseUrl}uploads/${this.state.trackDetails.customTrackImage}`}
                                            style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                                            alt="Track Image"
                                        />
                                    </div>
                                ) : ((this.state?.trackDetails?.trackImage) ? (
                                    <div style={{ backgroundColor: 'white', padding: 20, width: '90%'}}>
                                        <img
                                            src={
                                                (this.state.trackDetails?.song?.audio_source == 'spotify_url') ?
                                                    this.state.trackDetails.trackImage :
                                                    `${config.baseUrl}uploads/${this.state.trackDetails.trackImage}`
                                            }
                                            style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                                            alt="Track Image"
                                        />
                                    </div>
                                ) : null)}
                            </Grid2>
                            {/* <Grid2 item xs={12} sm={4} md={4} lg={3} xl={4} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                {(this.state?.trackDetails?.song?.spotify_url) ? (
                                    <div style={{ backgroundColor: 'white', padding: 20, width: '90%'}}>
                                        <QRCode
                                            size={400}
                                            style={{ height: "auto", maxWidth: "100%", width: '100%' }}
                                            value={this.state?.trackDetails?.song?.spotify_url}
                                            viewBox={`0 0 256 256`}
                                        />
                                    </div>
                                ) : null}
                            </Grid2> */}
                        </Stack>

                    </Stack>
                )}
                
            </Grid2>
        );
    }

    resultRender = () => {
        return (
            <Grid2 container spacing={2} sx={{ width: '100vw', height: '100vh' }} justifyContent={'space-around'} alignItems={'center'}>
                <Box>
                    <Text style={{ fontSize: 50, fontWeight: 'bold', color: 'gray' }}>{i18n.t('result')}</Text>
                </Box>
            </Grid2>
        );
    }

    render() {
        
        switch (this.state.currentState) {
            case STATES.WAITING:
                return this.waitingRender();
            case STATES.PLAYING:
                return this.playingRender();
            case STATES.ANSWER:
                return this.answerRender();
            case STATES.RESULT:
                return this.resultRender();
            default:
                return this.waitingRender();
        }

        // return (
        //     <View>
        //         <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', marginTop: 50 }}>


        //             <Text style={{ fontSize: 14, margin: 10 }}>{i18n.t('connection_status')}: {this.state.mqttStatus}</Text>

        //             {/* <Text style={{ fontSize: 16, margin: 10 }}>{i18n.t('group_id')}: {group_id}</Text> */}

        //             {this.state.songId ? (
        //                 <Text style={{ fontSize: 20, fontWeight: 'bold', margin: 10 }}>{i18n.t('song_id')}: {this.state.songId}</Text>
        //             ) : (
        //                 <Text style={{ fontSize: 20, fontWeight: 'bold', margin: 10 }}>{i18n.t('waiting_for_song_to_play')}</Text>
        //             )}


        //             {this.state.countdown > 0 ? (
        //                 <>
        //                     <View style={{ width: 50, height: 50, borderRadius: 25, backgroundColor: 'lightgray', justifyContent: 'center', alignItems: 'center', margin: 20 }}>
        //                         <Text style={{ fontSize: 30, fontWeight: '600' }}>{this.state.countdown}</Text>
        //                     </View>
        //                 </>
        //             ) : null}
        //         </View>
        //     </View>
        // );
    }
}


